import React from 'react';
import { InputText } from 'components/inputText/inputText';
import { formatText } from 'core/i18n';
import { getNamingValidationRegExp } from 'commonsUtilities/validations';
import validator from 'validator';

export const Name = ({ userProfile, userProfileForm, formActions, validateGroups, onFocus }) => {
    const handleRequiredField = value => value && value.length;

    const isNameValidForCountry = (value, country) => validator.matches(value, getNamingValidationRegExp[country]);

    const isValidNameLength = value => value.length <= 20 && value.length >= 2;

    const isValidName = value => isNameValidForCountry(value, __ORIGIN_COUNTRY__) && isValidNameLength(value);

    const handleValidations = {
        required: handleRequiredField,
        valid: isValidName,
    };

    const handleMessagesError = {
        required: formatText('validation-fieldRequired'),
        valid: formatText('validation-syntaxError'),
    };

    const handleIsValidated = () => {
        validateGroups?.('name', true);
    };

    const handleIsNotValidated = () => {
        validateGroups?.('name', false);
    };

    return (
        <div className="row form__input md-form-group">
            <div className="col-lg-12">
                <label htmlFor="name">{formatText('field-name')}</label>
            </div>
            <div className="col-sm-6">
                <InputText
                    profileModel="userProfile.name"
                    placeholder={formatText('field-placeholderName')}
                    type="text"
                    inputMode="text"
                    name="name"
                    autoCompleteFieldCustom={'given-name'}
                    defaultValue={userProfile.name}
                    validations={handleValidations}
                    isNotValidated={handleIsNotValidated}
                    isValidated={handleIsValidated}
                    messagesError={handleMessagesError}
                    errorClass="form__field_error name-errors"
                    userProfileForm={userProfileForm}
                    userProfile={userProfile}
                    formActions={formActions}
                    onFocus={onFocus}
                />
            </div>
        </div>
    );
};
